export default __webpack_public_path__ + "static/media/thumbnail.9ad15dc2.jpg";